export default "__VITE_ASSET__BkH203Wt__"